import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import LookBookQuoteContainer from "./../../components/lookBookQuoteContainer";
import CollectionHero from "./../../components/collectionHero";
import LookBookCenteredImage from "./../../components/lookBookCenteredImage";
import LookBookFullWidthImage from "./../../components/lookBookFullWidthImage";
import LookBookOnePhotoAndColor from "./../../components/lookBookOnePhotoAndColor";
import LookBookSideBySideImages from "./../../components/lookBookSideBySideImages";
import StoryFooter from "./../../components/storyFooter";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import BackButton from './../../alpineComponents/backButton';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class Nepal extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'The Joys of Jet Lag Exerpt | Nepal and the Art of Letting Go Kat Medina'}</title>
          <meta name="description" content="A sunrise hike in the Annapurna region of Nepal prompts reflection on openheartedness. Kat Medina explains the life-changing impact of blending surrender with drive." />
        </Helmet>
        <BackButton />
        <BannerFadeIn>
          <CollectionHero
            image={'/images/nepal-hero-main.jpg'}
            subtitle={'Nepal'}
            title={'The Art of Letting Go'}
            mobileOptimize={true}
          />
        </BannerFadeIn>
        <ScrollFadeIn>
          <LookBookOnePhotoAndColor
            backgroundColor="#16a5c4"
            image='/images/nepal-hiking.jpg'
            latlng={[28.399883,83.699570]}
            city="Ghorepani, Nepal"
          />
        </ScrollFadeIn>
        <div className="medium-padding">
          <div className="text-max-width-container">
            <ScrollFadeIn>
              <p className="tiny-padding">{'I adjusted my headlamp, zipped my red jacket, and pushed open the heavy door as I stepped into a blast of cool air. The stars were twinkling, and the moon was full enough to bathe the uneven, rocky path in a pale glow. Wind rustled the faded, once-colorful Tibetan prayer flags dancing softly in the early morning breeze. My friend Amber and I were on the second-to-last day of our four-day trek through the Annapurna region of Nepal, having awakened at four in the morning to hike to the top of Poon Hill in Ghorepani (pervy name, cool place). Several travelers joined us on the trail as we sleepily put one foot in front of the other in near silence. We were hoping for clear skies and an incredible sunrise, both of which were uncommon for that time of year. Shuffling through the darkness, it left time for the flowing thoughts that seem to naturally come about in hours typically spent sleeping.'}
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn>
              <p className="tiny-padding">{'I thought about the randomness of life. How imperfectly perfect every moment was and how seemingly fortuitous moments of openheartedness can lead to the most incredible unforeseen adventures. I felt like a leaf in a river. If I resisted life’s subtle guidance, it was as though I was blocked behind a rock of my own making. Whenever I let go, trusted, and said yes to whatever was in front of me with a receptive and open heart and mind, I would float onward, exactly to where I was meant to be. Life seemed to be a balance of surrender and drive. Coincidences seemed to be more like trail markers, offering the choice to continue straight ahead or veer off course and retreat. Each would lead to my destiny, but one tended to have serendipitous magic sprinkled along the way. I was learning how to trust.'}
              </p>
            </ScrollFadeIn>
          </div>
        </div>
        <ScrollFadeIn>
          <LookBookSideBySideImages
            images={[
              {
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/nepal-bridge-vert.jpg',
                  latlng:[28.399883,83.699570],
                  city:"Ghorepani, Nepal"
              },{
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/nepal-horses.jpg',
                  latlng:[28.399883,83.699570],
                  city:"Ghorepani, Nepal"
              },{
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/nepal-flags-mountain.jpg',
                  latlng:[28.399883,83.699570],
                  city:"Ghorepani, Nepal"
              }
            ]}
          />
        </ScrollFadeIn>
        <div className="medium-padding">
          <div className="text-max-width-container">
            <ScrollFadeIn>
              <p className="tiny-padding">{'So much of my life had been dedicated to achieving the goals or expectations that I had set for myself. I white-knuckled my way through countless situations, set on doing things the way I had intended and forcing it to go the way I thought was best. Occasionally, I would open up enough to let grace in. I would say yes to something that wasn’t on the “life schedule.” I would be open to a random conversation with a stranger, or an invitation to something out of my comfort zone. I realized that in those moments of discomfort I was shifting into a receptive mindset of growth and openness. I was allowing my inner voice of guidance to speak and be heard. The more I listened to it, the more it would speak up. The more I said yes, the more magic I would find. I was beginning to question whether all the rigid controlling I felt I had to do to achieve what I wanted was actually necessary. What if it was meant to be easier?'}
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn>
              <p className="tiny-padding">{'After about an hour of hiking, we arrived at the top of Poon Hill just as the sky was beginning to shift from night to day. It was a dimly lit blanket of grayish-purple light that was evolving and transforming with every blink. The air was filled with anticipation and excitement. The previous day was cloudy, cold, and raining with minimal visibility minus the occasional peekaboo of a rocky mountainside or a glimpse of the green valley floor thousands of feet below. Already, we could see the many peaks of the Annapurna range, clouds moving quickly as if they were trying to clear offstage in time for the big arrival of the main star. We settled into a spot that wasn’t too crowded and waited for the sunrise. It was a balance of appreciating the moment and looking forward to the next. Two stray mountain dogs played amongst the hikers, who warmed their hands on the sweet and spicy blend of masala tea sold from a lone shack nearby.'}</p>
            </ScrollFadeIn>
          </div>
        </div>
        <ScrollFadeIn>
          <LookBookCenteredImage
            image='/images/nepal-masala.jpg'
            latlng={[28.4002,83.6893]}
            city="Poon Hill, Nepal"
          />
        </ScrollFadeIn>
        <div className="medium-padding">
          <div className="text-max-width-container">
            <ScrollFadeIn>
              <p className="tiny-padding">{'Slowly, steadily, the sun rose, and the clouds moved lower to unveil the massive mountains in their full glory. The snowy mountain faces began to light up with a golden pink glow as the sun spread against their surface one by one. Hikers let out a collective gasp of awe. It felt like such an intimate moment and we, dozens of perfect strangers from all over the world, experienced it as one. Connected in a moment that would be forever ingrained in our memory, and a reminder of the beauty of life.'}</p>
            </ScrollFadeIn>
            <ScrollFadeIn>
              <p className="tiny-padding">{'The clouds framed the mountains so they appeared to float in the sky, almost as though we were looking at another planet. They stood at just over 26,000 feet in elevation, and with us at a mere 10,000 feet, they had an almost otherworldly effect. To be so high up and yet looking at something 2.5 times higher filled me with indescribable appreciation. It was beautiful. It was in that moment of incredulous wonder that I felt consumed by gratitude. How lucky was I to be witnessing this? The odds of a picture-perfect sunrise with fantastic conditions were slim to none considering the forecast. And yet, with a balance of drive and trust—continuing on hiking, hoping, appreciating the journey—we were gifted with the results of surrender at its finest.'}</p>
            </ScrollFadeIn>
          </div>
        </div>
        <ScrollFadeIn>
          <LookBookFullWidthImage
            image='/images/nepal-bridge-hero.jpg'
            latlng={[28.399883,83.699570]}
            city="Ghorepani, Nepal"
          />
        </ScrollFadeIn>
        <StoryFooter story="/nepal" />
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/nepal/index.js